import { gql } from "@apollo/client";

export const FETCH_PRODUCTS = gql`
  query GetProducts {
    getAllProduct {
      costOfSales
      grossMargin
      name
      revenue
      uuid
    }
  }
`;

export const CREATE_PRODUCT = gql`
  mutation product($data: CreateProductFinancialInput!) {
    createProduct(data: $data) {
      costOfSales
      grossMargin
      name
      revenue
      uuid
    }
  }
`;

export const EDIT_PRODUCT = gql`
  mutation product($data: UpdateProductFinancialInput!) {
    updateProduct(data: $data) {
      costOfSales
      grossMargin
      name
      revenue
      uuid
    }
  }
`;

export const DELETE_PRODUCT = gql`
  mutation productRemove($uuid: ID!) {
    deleteProduct(uuid: $uuid) {
      costOfSales
      grossMargin
      name
      revenue
      uuid
    }
  }
`;

export const FETCH_PRODUCT_BY_PRODUCT_GROUP = gql`
  query GetProductByProductGroup($uuid: ID!) {
    getAllProductsByProductGroup(uuid: $uuid) {
      costOfSales
      grossMargin
      isDefault
      name
      percentage
      revenue
      uuid
    }
  }
`;
